export interface GetNotificationsResults extends Array<Item> {}

interface Item {
  _id: number
  type: string
  content: string
}

export default function getNotifications({
  get,
}: any): Promise<GetNotificationsResults> {
  return get(`/notifications`, {}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/notifications/getNotifications.tsx